import axios from 'axios'

async function searchCep(cep) {

    try {
        const result = await axios.get(`https://viacep.com.br/ws/${cep}/json/`, {}, {})
    
        return result.data

    } catch (error) {

        return false
    }


}

export default searchCep